/**
 * Search drawer — fixed product + collection results
 * Fixes:
 * 1. Duplicate products (old inline script scraped /search HTML with overlapping selectors)
 * 2. Collections not matching multi-word queries like "cross pendant"
 * 3. iOS: old + new both binding → double results
 *
 * Upload to: assets/new-search-drawer-search.js (replace existing file)
 * In snippets/new-search-drawer.liquid: DELETE any inline <script> with performSearch.
 * Load this asset once only (snippet OR theme.liquid — not both).
 */
(function () {
  if (window.__OL_SEARCH_DRAWER_INIT__) return;
  window.__OL_SEARCH_DRAWER_INIT__ = true;

  function afterOthers(fn) {
    function run() {
      // Two ticks so late inline DOMContentLoaded binders finish first on iOS
      setTimeout(function () {
        setTimeout(fn, 0);
      }, 0);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  }

  afterOthers(function () {
    var searchDrawer = document.getElementById('searchDrawer');
    var overlay = document.getElementById('searchDrawerOverlay');
    var closeBtn = document.getElementById('closeSearchDrawer');
    var searchInput = document.getElementById('searchInput');
    var searchSubmitBtn = document.getElementById('searchSubmitBtn');
    var searchLeftColumn = document.getElementById('searchLeftColumn');
    var searchRightContent = document.querySelector('.search-right-content');
    var defaultCollectionsWrapper = document.getElementById('defaultCollectionsWrapper');
    var searchResultsContainer = document.getElementById('searchResultsContainer');

    if (!searchDrawer || !searchInput) return;

    function stripAndReplace(el) {
      if (!el || !el.parentNode) return el;
      var fresh = el.cloneNode(true);
      el.parentNode.replaceChild(fresh, el);
      return fresh;
    }

    searchInput = stripAndReplace(searchInput);
    searchInput.setAttribute('data-ol-search-bound', '1');
    if (searchSubmitBtn) searchSubmitBtn = stripAndReplace(searchSubmitBtn);
    if (closeBtn) closeBtn = stripAndReplace(closeBtn);
    if (overlay) overlay = stripAndReplace(overlay);

    var searchTimeout;
    var currentSearchTerm = '';
    var allCollections = [];
    var searchRequestId = 0;
    var abortController = null;

    function escapeHtml(text) {
      if (!text) return '';
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    function toggleViews(isSearching) {
      if (!defaultCollectionsWrapper || !searchResultsContainer) return;
      if (isSearching) {
        defaultCollectionsWrapper.style.display = 'none';
        searchResultsContainer.style.display = 'flex';
      } else {
        defaultCollectionsWrapper.style.display = 'block';
        searchResultsContainer.style.display = 'none';
        if (searchLeftColumn) {
          searchLeftColumn.innerHTML = '';
          searchLeftColumn.classList.remove('hide-column');
        }
        if (searchRightContent) searchRightContent.innerHTML = '';
        searchDrawer.classList.remove('expanded');
      }
    }

    function updateDrawerSize(hasProducts) {
      if (!searchDrawer) return;
      searchDrawer.classList.toggle('expanded', !!hasProducts);
    }

    function toggleLeftColumn(hasProducts) {
      if (!searchLeftColumn) return;
      searchLeftColumn.classList.toggle('hide-column', !hasProducts);
    }

    async function fetchAllCollections() {
      try {
        var allCol = [];
        var page = 1;
        var hasNextPage = true;
        while (hasNextPage && page <= 10) {
          var response = await fetch('/collections.json?limit=250&page=' + page);
          var data = await response.json();
          if (data.collections && data.collections.length > 0) {
            allCol = allCol.concat(data.collections);
            page += 1;
          } else {
            hasNextPage = false;
          }
        }
        allCollections = allCol.filter(function (c) {
          return c.handle !== 'frontpage' && c.handle !== 'all' && c.handle !== 'shop-all';
        });
        return allCollections;
      } catch (error) {
        console.error('Error fetching collections:', error);
        return [];
      }
    }

    var collectionsPromise = null;
    function ensureCollectionsLoaded() {
      if (!collectionsPromise) collectionsPromise = fetchAllCollections();
      return collectionsPromise;
    }

    window.openSearchDrawer = function () {
      searchDrawer.classList.add('open');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      var layout = document.querySelector('.outrage-layout');
      if (layout) layout.style.overflow = 'hidden';

      ensureCollectionsLoaded();

      toggleViews(false);
      searchInput.value = '';
      currentSearchTerm = '';

      var productsWrapper = document.getElementById('defaultProductsWrapper');
      if (productsWrapper) productsWrapper.style.display = 'block';

      setTimeout(function () {
        try {
          searchInput.focus();
        } catch (e) {}
      }, 300);
    };

    function closeSearchDrawer() {
      searchDrawer.classList.remove('open');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
      var layout = document.querySelector('.outrage-layout');
      if (layout) layout.style.overflow = '';

      searchInput.value = '';
      currentSearchTerm = '';
      toggleViews(false);
      if (searchLeftColumn) {
        searchLeftColumn.innerHTML = '';
        searchLeftColumn.classList.remove('hide-column');
      }
      if (searchRightContent) searchRightContent.innerHTML = '';
      searchDrawer.classList.remove('expanded');
    }

    if (closeBtn) closeBtn.addEventListener('click', closeSearchDrawer);
    if (overlay) overlay.addEventListener('click', closeSearchDrawer);

    function uniqueByUrl(items) {
      var seen = {};
      var out = [];
      items.forEach(function (item) {
        if (!item) return;
        var urlKey = String(item.url || '')
          .split('?')[0]
          .replace(/\/$/, '')
          .replace(/^https?:\/\/[^/]+/i, '');
        var titleKey = String(item.title || '')
          .toLowerCase()
          .trim();
        var key = urlKey || titleKey;
        if (!key) return;
        if (seen[key] || (titleKey && seen['t:' + titleKey])) return;
        seen[key] = true;
        if (titleKey) seen['t:' + titleKey] = true;
        out.push(item);
      });
      return out;
    }

    function productImageUrl(product) {
      if (!product) return '';
      if (product.image) {
        return String(product.image).replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2');
      }
      if (product.featured_image) {
        if (typeof product.featured_image === 'string') return product.featured_image;
        if (product.featured_image.url) return product.featured_image.url;
      }
      return '';
    }

    // Fee / internal products (engraving position addon, gift wrap, etc.)
    // must never appear in customer-facing search.
    function isHiddenStorefrontAddon(product) {
      if (!product) return true;
      var title = String(product.title || '').toLowerCase().trim();
      var handle = String(product.handle || '').toLowerCase().trim();
      if (!handle && product.url) {
        var match = String(product.url).match(/\/products\/([^/?#]+)/i);
        if (match) {
          try {
            handle = decodeURIComponent(match[1]).toLowerCase();
          } catch (err) {
            handle = String(match[1]).toLowerCase();
          }
        }
      }

      if (/^engraving(\s|:|$)/.test(title)) return true;
      if (title.indexOf('engraving position') !== -1) return true;
      if (title.indexOf('engraving text') !== -1) return true;
      if (title.indexOf('engraving emoji') !== -1) return true;
      if (title.indexOf('engraving font') !== -1) return true;
      if (title.indexOf('engraving location') !== -1) return true;
      if (title.indexOf('engraving comment') !== -1) return true;
      if (title.indexOf('engraving custom') !== -1) return true;
      if (title.indexOf('handwritten message') !== -1 && (title.indexOf('addon') !== -1 || handle.indexOf('engraving') === 0 || handle.indexOf('handwritten') !== -1)) {
        return true;
      }
      if (/\baddon\b/.test(title)) return true;

      if (handle === 'engraving' || handle.indexOf('engraving-') === 0) return true;
      if (handle.indexOf('-addon') !== -1 || handle.indexOf('addon-') === 0) return true;
      if (handle === 'chain-extender' || handle.indexOf('chain-extender') === 0) return true;
      if (handle.indexOf('gift-product') === 0 || handle.indexOf('gift-wrap') === 0 || handle.indexOf('presentation-box') === 0) {
        return true;
      }
      if (handle.indexOf('personalisation-') === 0 || handle.indexOf('personalization-') === 0) return true;
      if (handle.indexOf('free-jewellery') === 0 || handle.indexOf('free-jewelry') === 0) return true;
      if (handle.indexOf('shipping-gift') === 0 || handle.indexOf('insurance') === 0) return true;

      return false;
    }

    function productHandleFromSuggest(p) {
      if (p && p.handle) return String(p.handle);
      if (p && p.url) {
        var match = String(p.url).match(/\/products\/([^/?#]+)/i);
        if (match) {
          try {
            return decodeURIComponent(match[1]);
          } catch (err) {
            return match[1];
          }
        }
      }
      return '';
    }

    function collectionMatchScore(collection, term) {
      var title = (collection.title || '').toLowerCase();
      var handle = (collection.handle || '').toLowerCase().replace(/-/g, ' ');
      var haystack = title + ' ' + handle;
      var score = 0;

      if (haystack.indexOf(term) !== -1) score += 100;

      var words = term.split(/\s+/).filter(function (w) {
        return w.length >= 3;
      });
      words.forEach(function (word) {
        if (title === word || handle === word) score += 40;
        else if (title.indexOf(word) !== -1 || handle.indexOf(word) !== -1) score += 20;
      });

      return score;
    }

    function getMatchingCollections(query) {
      var term = (query || '').toLowerCase().trim();
      if (!term) return [];

      return allCollections
        .map(function (collection) {
          return { collection: collection, score: collectionMatchScore(collection, term) };
        })
        .filter(function (row) {
          return row.score > 0;
        })
        .sort(function (a, b) {
          return b.score - a.score;
        })
        .map(function (row) {
          return row.collection;
        });
    }

    async function fetchSuggestProducts(query, signal) {
      var url =
        '/search/suggest.json?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product' +
        '&resources[limit]=20' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

      var response = await fetch(url, signal ? { signal: signal } : undefined);
      var data = await response.json();
      var raw = (data.resources && data.resources.results && data.resources.results.products) || [];

      return uniqueByUrl(
        raw
          .map(function (p) {
            return {
              title: p.title,
              url: p.url,
              handle: productHandleFromSuggest(p),
              featured_image: productImageUrl(p)
            };
          })
          .filter(function (p) {
            return !isHiddenStorefrontAddon(p);
          })
      );
    }

    /* Predictive search is lexical, so a query whose wording does not appear in
       any product returns nothing at all - which is what left the drawer empty
       under "COLLECTION SUGGESTIONS". Ask the semantic index next. */
    async function fetchSemanticProducts(query, signal) {
      var endpoint = window.OL_AI_SEARCH_ENDPOINT;
      if (!endpoint) return [];
      try {
        var res = await fetch(
          endpoint + '?q=' + encodeURIComponent(query) + '&limit=8',
          signal ? { signal: signal } : undefined
        );
        if (!res.ok) return [];
        var data = await res.json();
        return (data.results || []).map(function (p) {
          return {
            title: p.title,
            url: '/products/' + p.handle,
            handle: p.handle,
            featured_image: p.image || ''
          };
        });
      } catch (err) {
        return [];
      }
    }

    /* Last resort: the bestsellers already rendered into the drawer, reused
       rather than re-fetched. Showing them beats an empty panel - the shopper
       searched for something the shop does not sell, and a way forward is more
       use than a blank space. */
    function readBestsellerFallback() {
      var grid = document.getElementById('defaultProductsGrid');
      if (!grid) return [];
      return [].slice.call(grid.querySelectorAll('.default-product-data'))
        .map(function (el) {
          try {
            var p = JSON.parse(el.textContent);
            return {
              title: p.title,
              url: p.url,
              handle: p.handle,
              featured_image: p.featured_image
                ? String(p.featured_image).replace(/(\.[a-z]+)(\?|$)/i, '_300x300$1$2')
                : ''
            };
          } catch (err) {
            return null;
          }
        })
        .filter(Boolean);
    }

    function displayCollectionsSuggestions(query) {
      if (!searchRightContent) return;

      var matchingCollections = getMatchingCollections(query);

      if (matchingCollections.length > 0) {
        var html =
          '<div class="search-collection-section">' +
          '<h4 class="search-collection-title">COLLECTION SUGGESTIONS</h4>' +
          '<ul class="search-collection-list">';

        matchingCollections.slice(0, 10).forEach(function (collection) {
          html +=
            '<li class="search-collection-item">' +
            '<a href="/collections/' +
            encodeURIComponent(collection.handle).replace(/%2F/g, '/') +
            '">' +
            '<div class="collection-item-left">' +
            '<div><span class="suggestion-suggestion-text">' +
            escapeHtml(collection.title) +
            '</span></div>' +
            '<span class="suggestion-subtitle">Browse ' +
            escapeHtml(collection.title) +
            ' →</span>' +
            '</div>' +
            '<span class="collection-item-arrow">→</span>' +
            '</a></li>';
        });

        html += '</ul></div>';
        searchRightContent.innerHTML = html;
      } else if (query && query.trim().length >= 2) {
        searchRightContent.innerHTML =
          '<div class="empty-right-message">No collections found matching "' +
          escapeHtml(query.trim()) +
          '"</div>';
      }
    }

    function displayLeftColumn(products, query) {
      if (!searchLeftColumn) return;

      products = uniqueByUrl(products || []);

      if (products.length > 0) {
        var html =
          '<div class="products-section-header">' +
          '<h3>PRODUCTS</h3>' +
          '<a href="/search?q=' +
          encodeURIComponent(query) +
          '&type=product" class="view-all-link">View All →</a>' +
          '</div><div class="products-grid">';

        products.slice(0, 6).forEach(function (product) {
          var imageUrl = product.featured_image || '';
          html +=
            '<a href="' +
            product.url +
            '" class="product-card">' +
            (imageUrl
              ? '<img class="product-card-image" src="' +
                imageUrl +
                '" alt="' +
                escapeHtml(product.title) +
                '" loading="lazy">'
              : '<div class="product-card-image" style="background:#f0f0f0;"></div>') +
            '<div class="product-card-title">' +
            escapeHtml(product.title) +
            '</div></a>';
        });

        html += '</div>';
        searchLeftColumn.innerHTML = html;
      } else {
        searchLeftColumn.innerHTML =
          '<div class="empty-right-message">No products found</div>';
        searchLeftColumn.classList.add('hide-column');
      }
    }

    async function performSearch(query) {
      if (!query || query.length < 2) {
        toggleViews(false);
        return;
      }

      var requestId = ++searchRequestId;
      toggleViews(true);

      if (abortController) {
        try {
          abortController.abort();
        } catch (e) {}
      }
      abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;

      if (searchLeftColumn) {
        searchLeftColumn.innerHTML = '<div class="loading-spinner">Searching products...</div>';
        searchLeftColumn.classList.remove('hide-column');
      }

      displayCollectionsSuggestions(query);

      try {
        if (!allCollections.length) await ensureCollectionsLoaded();
        if (requestId !== searchRequestId) return;

        displayCollectionsSuggestions(query);

        var products = await fetchSuggestProducts(
          query,
          abortController ? abortController.signal : null
        );
        if (requestId !== searchRequestId) return;

        if (!products.length) {
          products = await fetchSemanticProducts(
            query,
            abortController ? abortController.signal : null
          );
          if (requestId !== searchRequestId) return;
        }
        if (!products.length) {
          products = readBestsellerFallback();
        }

        var hasProducts = products.length > 0;
        updateDrawerSize(hasProducts);
        toggleLeftColumn(hasProducts);
        displayLeftColumn(products, query);
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        console.error('Search error:', error);
        if (requestId !== searchRequestId) return;
        displayCollectionsSuggestions(query);
        if (searchLeftColumn) {
          searchLeftColumn.innerHTML = '<div class="empty-right-message">Search unavailable</div>';
        }
      }
    }

    // Capture phase + stopImmediatePropagation blocks leftover old iOS listeners
    searchInput.addEventListener(
      'input',
      function (e) {
        e.stopImmediatePropagation();
        clearTimeout(searchTimeout);
        var query = (e.target.value || '').trim();
        currentSearchTerm = query;

        if (query.length >= 2) {
          searchTimeout = setTimeout(function () {
            performSearch(query);
          }, 300);
        } else {
          toggleViews(false);
          searchDrawer.classList.remove('expanded');
        }
      },
      true
    );

    searchInput.addEventListener('keypress', function (e) {
      if (e.key === 'Enter' && currentSearchTerm.length >= 2) {
        clearTimeout(searchTimeout);
        window.location.href = '/search?q=' + encodeURIComponent(currentSearchTerm) + '&type=product';
        closeSearchDrawer();
      }
    });

    if (searchSubmitBtn) {
      searchSubmitBtn.addEventListener('click', function () {
        if (currentSearchTerm.length >= 2) {
          window.location.href = '/search?q=' + encodeURIComponent(currentSearchTerm) + '&type=product';
          closeSearchDrawer();
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchDrawer.classList.contains('open')) {
        closeSearchDrawer();
      }
    });

    function initDefaultProductsAddToCart() {
      document.querySelectorAll('.default-variant-select').forEach(function (select) {
        if (select.getAttribute('data-ol-bound') === '1') return;
        select.setAttribute('data-ol-bound', '1');
        select.addEventListener('change', function () {
          var productCard = this.closest('.default-product-card');
          var selectedOption = this.options[this.selectedIndex];
          var variantId = this.value;
          var variantPrice = selectedOption.dataset.price;
          var atcBtn = productCard.querySelector('.default-add-to-cart-btn');
          if (atcBtn) atcBtn.setAttribute('data-variant-id', variantId);
          var priceElement = productCard.querySelector('.default-product-price');
          if (priceElement && variantPrice) priceElement.textContent = variantPrice;
        });
      });

      document.querySelectorAll('.default-add-to-cart-btn').forEach(function (btn) {
        if (btn.getAttribute('data-ol-bound') === '1') return;
        btn.setAttribute('data-ol-bound', '1');

        btn.addEventListener('click', async function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (this.classList.contains('loading')) return;

          var variantId = this.getAttribute('data-variant-id');
          var productCard = this.closest('.default-product-card');
          var variantSelect = productCard && productCard.querySelector('.default-variant-select');
          if (variantSelect) variantId = variantSelect.value;
          if (!variantId) return;

          this.classList.add('loading');
          var originalText = this.innerHTML;
          var self = this;
          try {
            var response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
            });
            var data = await response.json();
            if (response.ok) {
              this.innerHTML =
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg> Added!';
              setTimeout(function () {
                self.innerHTML = originalText;
              }, 2000);
              document.dispatchEvent(new CustomEvent('cart:build'));
              document.dispatchEvent(new CustomEvent('cart:open'));
            } else {
              console.error('Cart error:', data);
              this.innerHTML = 'Error!';
              setTimeout(function () {
                self.innerHTML = originalText;
              }, 2000);
            }
          } catch (err) {
            console.error('Add to cart error:', err);
            this.innerHTML = 'Error!';
            setTimeout(function () {
              self.innerHTML = originalText;
            }, 2000);
          } finally {
            this.classList.remove('loading');
          }
        });
      });
    }

    initDefaultProductsAddToCart();

    var openBase = window.openSearchDrawer;
    window.openSearchDrawer = function () {
      openBase();
      setTimeout(initDefaultProductsAddToCart, 100);
    };

    toggleViews(false);
  });
})();
